var _excluded = ["children", "as", "type", "fontWeight"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import styled, { css } from 'styled-components';
import { system, display } from 'styled-system';
import { shouldForwardProp } from '../../utils';
import { strictSpace } from '../../utils';
import { screenReaderOnly } from '../../components/Mixins/Mixins';
import useTheme from '../../useTheme';
var align = system({
  align: {
    property: 'textAlign'
  }
});
var StyledText = styled.p.withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "Text__StyledText",
  componentId: "sc-8673af-0"
})(["", " ", " ", " font-size:", ";line-height:", ";font-weight:", ";font-family:", ";color:", ";", " ", " ", ";", ""], display, strictSpace, align, function (props) {
  return props.fontSize;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.fontWeight;
}, function (_ref) {
  var fontFamily = _ref.fontFamily;
  return fontFamily;
}, function (_ref2) {
  var theme = _ref2.theme,
      color = _ref2.color;
  return color && theme.colors[color];
}, function (props) {
  return props.caps && 'text-transform: uppercase';
}, function (props) {
  return props.screenReaderOnly && screenReaderOnly;
}, function (props) {
  return props.lineClamp && css(["display:-webkit-box;-webkit-line-clamp:", ";-webkit-box-orient:vertical;overflow:hidden;"], props.lineClamp);
}, function (props) {
  return props.whiteSpace && "white-space: ".concat(props.whiteSpace);
});
StyledText.defaultProps = {
  mt: '0',
  mb: '0',
  color: 'textPrimary'
};

var Text = function Text(_ref3) {
  var children = _ref3.children,
      as = _ref3.as,
      type = _ref3.type,
      fontWeight = _ref3.fontWeight,
      rest = _objectWithoutProperties(_ref3, _excluded);

  var _useTheme = useTheme(),
      fonts = _useTheme.fonts,
      fontFamilies = _useTheme.fontFamilies,
      fontWeights = _useTheme.fontWeights;

  var _fonts$type = fonts[type],
      fontFamily = _fonts$type.fontFamily,
      defaultEl = _fonts$type.defaultEl,
      lineHeight = _fonts$type.lineHeight,
      fontSize = _fonts$type.fontSize;
  var configProps = {
    fontFamily: fontFamilies[fontFamily],
    fontWeight: fontWeights[fontFamily][fontWeight],
    fontSize: fontSize,
    lineHeight: lineHeight,
    as: as ? as : defaultEl ? defaultEl : undefined
  };
  return /*#__PURE__*/React.createElement(StyledText, _extends({}, rest, configProps), children);
};

Text.defaultProps = {
  fontWeight: 'default'
};
export default Text;